// @react
import React, { ReactElement } from 'react'
// @graphql
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
// @components
import AccountAccessForm from 'modules/profile/components/AccountAccess/Form'
import QueryError from '../../../common/components/Errors/QueryError'

/**
 * 5.0.2.1 Profile - Security - AccountAccess
 * UX: https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3123%3A16072
 *
 * fields
 * primaryEmailAddress
 */

const AccountAccessContainer = (): ReactElement => {
  /******************************************
   * HOOKS
   ******************************************/
  const { loading: isLoading, error: isError, data } = useQuery<
    GetUserQuery,
    GetUserQueryVariables
  >(GET_USER, { fetchPolicy: 'cache-first' })

  /******************************************
   * RENDER
   ******************************************/
  if (isError || (!data && !isLoading)) {
    return <QueryError />
  }

  return <AccountAccessForm data={data} isLoading={isLoading} />
}

export default AccountAccessContainer
